/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-pin.js
 *
 * 指定した要素を固定するスクロールアニメーション用
 *
 * 目次
 * __00: 初期設定
 * __10: 吹き出し
 * __20: ヘッダー
 * __30: インタビュアー
 * __40: MV
 * __50: 下層ページ - インタビュイー
 * __60: 下層ページ - 白泉社の職種紹介
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 
 * __00: 初期設定
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let speed = 110;
const scrollArea = document.body;
function setWindowHeight() {
  var setWH = window.innerHeight;
  return setWH;
}
/**
 * 
 * __10: 吹き出し
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function bubbleAnimation() {
  let WindowHeight = setWindowHeight();
  let bubbles = document.getElementById("bubbles");

  /**
   * 吹き出し全体
   */
  let bubblesTl = gsap.timeline();

  ScrollTrigger.create({
    animation: bubblesTl,
    trigger: scrollArea,
    start: `${WindowHeight}px top`,
    end: `${WindowHeight * 3}px top`,
    scrub: 2,
    // markers: true,
  })

  bubblesTl.to(bubbles, { scale: 3.5 }, 0);

  /**
   * 吹き出し単体
   */
  let bubbleTl = gsap.timeline();

  ScrollTrigger.create({
    animation: bubbleTl,
    trigger: scrollArea,
    start: `${WindowHeight * 1.5}px top`,
    end: `${WindowHeight * 3}px top`,
    scrub: 2,
    // markers: true,
  })

  if (window.matchMedia("(min-width: 600px)").matches) {
    bubbleTl.to('#bubble01', { x: -3 * speed, y: -2 * speed }, 0.06);
    bubbleTl.to('#bubble02', { x: -1 * speed, y: -2 * speed }, 0.1);
    bubbleTl.to('#bubble03', { x: 0, y: -2 * speed }, 0.08);
    bubbleTl.to('#bubble04', { x: 1.5 * speed, y: -2 * speed }, 0.12);
    bubbleTl.to('#bubble05', { x: 3 * speed, y: -2 * speed }, 0.06);
    bubbleTl.to('#bubble06', { x: -3 * speed, y: 2 * speed }, 0.14);
    bubbleTl.to('#bubble07', { x: -1 * speed, y: 2 * speed }, 0.12);
    bubbleTl.to('#bubble08', { x: 0, y: 2 * speed }, 0.09);
    bubbleTl.to('#bubble09', { x: 1 * speed, y: 2 * speed }, 0.1);
    bubbleTl.to('#bubble10', { x: 3 * speed, y: 2 * speed }, 0.06);
  } else {
    bubbleTl.to('#bubble01', { x: -2 * speed, y: -2 * speed }, 0.06);
    bubbleTl.to('#bubble02', { x: -2 * speed, y: -1 * speed }, 0.04);
    bubbleTl.to('#bubble03', { x: -2 * speed, y: 0 * speed }, 0.01);
    bubbleTl.to('#bubble04', { x: -2 * speed, y: 1 * speed }, 0.05);
    bubbleTl.to('#bubble05', { x: -2 * speed, y: 2 * speed }, 0.06);
    bubbleTl.to('#bubble06', { x: 2 * speed, y: -2 * speed }, 0.06);
    bubbleTl.to('#bubble07', { x: 2 * speed, y: -1 * speed }, 0.06);
    bubbleTl.to('#bubble08', { x: 2 * speed, y: 0 * speed }, 0.01);
    bubbleTl.to('#bubble09', { x: 2 * speed, y: 1 * speed }, 0.04);
    bubbleTl.to('#bubble10', { x: 2 * speed, y: 2 * speed }, 0.06);
  }
}

/**
 * 
 * __20: ヘッダー
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function headerAnimation() {
  let WindowHeight = setWindowHeight();
  let header = document.getElementById("header");
  let pageBottomNav = document.getElementById("pageBottomNav");
  let headerTl = gsap.timeline();

  gsap.set(header, { y: -100 });
  gsap.set(pageBottomNav, { y: 80 });

  ScrollTrigger.create({
    animation: headerTl,
    trigger: scrollArea,
    start: `${WindowHeight * 2}px top`,
    end: `${WindowHeight * 2}px top`,
    scrub: 2,
  })

  headerTl.to([header, pageBottomNav], { y: 0 }, 0);
}

/**
 * 
 * __30: インタビュアー
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * 巽 響（たつみ ひびき） x 深谷 実咲（ふかや みさき）
 */
function intervieweeSet01Animation() {
  let WindowHeight = setWindowHeight();
  let intervieweeSet01 = document.getElementById('interviewee-set01');
  let set01_1 = document.getElementById('set01-1'); //巽 響（たつみ ひびき）
  let set01_2 = document.getElementById('set01-2'); //深谷 実咲（ふかや みさき）
  let set01_1_cat1 = document.getElementById('set01-1-cat1');
  let set01_1_cat2 = document.getElementById('set01-1-cat2');
  let set01_2_cat1 = document.getElementById('set01-2-cat1');
  let set01_2_cat2 = document.getElementById('set01-2-cat2');
  let intervieweeTl1 = gsap.timeline();
  let intervieweeTl2 = gsap.timeline();
  let intervieweeTl3 = gsap.timeline();
  let intervieweeCatTl = gsap.timeline();

  gsap.set(intervieweeSet01, { opacity: 0, scale: 0.5 });

  //opacity用
  gsap.to(intervieweeSet01, {
    opacity: 1,
    scrollTrigger: {
      trigger: scrollArea,
      start: `${WindowHeight * 2}px top`,
      end: `${WindowHeight * 2.25}px top`,
      scrub: 2,
    }
  }, 0);

  //動き用1
  ScrollTrigger.create({
    animation: intervieweeTl1,
    trigger: scrollArea,
    start: `${WindowHeight * 2}px top`,
    end: `${WindowHeight * 4}px top`,
    scrub: 2,
  })

  intervieweeTl1.to(intervieweeSet01, { scale: 3 });

  //動き用2
  ScrollTrigger.create({
    animation: intervieweeTl2,
    trigger: scrollArea,
    start: `${WindowHeight * 2.5}px top`,
    end: `${WindowHeight * 4}px top`,
    scrub: 2,
  })

  if (window.matchMedia("(min-width: 600px)").matches) {
    intervieweeTl2.to([set01_1, set01_2], { y: 3 * speed }, "<");
    intervieweeTl2.to(set01_1, { x: -100, scale: 2 }, 0);
    intervieweeTl2.to(set01_2, { x: 100, scale: 2 }, 0);
  } else {
    intervieweeTl2.to([set01_1, set01_2], { y: 2 * speed }, "<");
    intervieweeTl2.to(set01_1, { x: -10, scale: 2 }, 0);
    intervieweeTl2.to(set01_2, { x: 10, scale: 2 }, 0);
  }

  //カット用
  ScrollTrigger.create({
    animation: intervieweeCatTl,
    trigger: scrollArea,
    start: `${WindowHeight * 2.85}px top`,
    end: `${WindowHeight * 2.85}px top`,
    scrub: 2,
  })

  intervieweeCatTl.to([set01_1_cat1, set01_2_cat1], { opacity: 0, duration: 1, }, "<");
  intervieweeCatTl.to([set01_1_cat2, set01_2_cat2], { opacity: 1, duration: 1, }, "<");

  //動き用３
  ScrollTrigger.create({
    animation: intervieweeTl3,
    trigger: scrollArea,
    start: `${WindowHeight * 4}px top`,
    end: `${WindowHeight * 4}px top`,
    scrub: 2,
  })

  intervieweeTl3.to([set01_1, set01_2], { opacity: 0 }, 0);
}

/**
 * 河野 めぐみ（こうの めぐみ） x 高村 亮（たかむら りょう）
 */
function intervieweeSet02Animation() {
  let WindowHeight = setWindowHeight();
  let intervieweeSet02 = document.getElementById('interviewee-set02');
  let set02_1 = document.getElementById('set02-1'); //河野 めぐみ（こうの めぐみ）
  let set02_2 = document.getElementById('set02-2'); //高村 亮（たかむら りょう）
  let set02_1_cat1 = document.getElementById('set02-1-cat1');
  let set02_1_cat2 = document.getElementById('set02-1-cat2');
  let set02_2_cat1 = document.getElementById('set02-2-cat1');
  let set02_2_cat2 = document.getElementById('set02-2-cat2');
  let intervieweeTl1 = gsap.timeline();
  let intervieweeTl2 = gsap.timeline();
  let intervieweeTl3 = gsap.timeline();
  let intervieweeCatTl = gsap.timeline();

  gsap.set(intervieweeSet02, { opacity: 0, scale: 0.5 });

  //opacity用
  gsap.to(intervieweeSet02, {
    opacity: 1,
    scrollTrigger: {
      trigger: scrollArea,
      start: `${WindowHeight * 3}px top`,
      end: `${WindowHeight * 3.25}px top`,
      scrub: 2,
    }
  }, 0);

  //動き用1
  ScrollTrigger.create({
    animation: intervieweeTl1,
    trigger: scrollArea,
    start: `${WindowHeight * 3}px top`,
    end: `${WindowHeight * 5}px top`,
    scrub: 2,
  })

  intervieweeTl1.to(intervieweeSet02, { scale: 3 });

  //動き用2
  ScrollTrigger.create({
    animation: intervieweeTl2,
    trigger: scrollArea,
    start: `${WindowHeight * 3.25}px top`,
    end: `${WindowHeight * 5}px top`,
    scrub: 2,
  })

  if (window.matchMedia("(min-width: 600px)").matches) {
    intervieweeTl2.to([set02_1, set02_2], { y: 3 * speed }, "<");
    intervieweeTl2.to(set02_1, { x: -100, scale: 2 }, 0);
    intervieweeTl2.to(set02_2, { x: 100, scale: 2 }, 0);
  } else {
    intervieweeTl2.to([set02_1, set02_2], { y: 2 * speed }, "<");
    intervieweeTl2.to(set02_1, { x: -10, scale: 2 }, 0);
    intervieweeTl2.to(set02_2, { x: 10, scale: 2 }, 0);
  }

  //カット用
  ScrollTrigger.create({
    animation: intervieweeCatTl,
    trigger: scrollArea,
    start: `${WindowHeight * 3.85}px top`,
    end: `${WindowHeight * 3.85}px top`,
    scrub: 2,
  })

  intervieweeCatTl.to([set02_1_cat1, set02_2_cat1], { opacity: 0, duration: 1, }, "<");
  intervieweeCatTl.to([set02_1_cat2, set02_2_cat2], { opacity: 1, duration: 1, }, "<");

  //動き用３
  ScrollTrigger.create({
    animation: intervieweeTl3,
    trigger: scrollArea,
    start: `${WindowHeight * 5}px top`,
    end: `${WindowHeight * 5}px top`,
    scrub: 2,
  })

  intervieweeTl3.to([set02_1, set02_2], { opacity: 0 }, 0);
}

/**
 * 大場 友喜（おおば ともき） x 城間 亜龍（しろま ありゅう）
 */
function intervieweeSet03Animation() {
  let WindowHeight = setWindowHeight();
  let intervieweeSet03 = document.getElementById('interviewee-set03');
  let set03_1 = document.getElementById('set03-1'); //大場 友喜（おおば ともき）
  let set03_2 = document.getElementById('set03-2'); //城間 亜龍（しろま ありゅう）
  let set03_1_cat1 = document.getElementById('set03-1-cat1');
  let set03_1_cat2 = document.getElementById('set03-1-cat2');
  let set03_2_cat1 = document.getElementById('set03-2-cat1');
  let set03_2_cat2 = document.getElementById('set03-2-cat2');
  let intervieweeTl1 = gsap.timeline();
  let intervieweeTl2 = gsap.timeline();
  let intervieweeTl3 = gsap.timeline();
  let intervieweeCatTl = gsap.timeline();

  gsap.set(intervieweeSet03, { opacity: 0, scale: 0.5 });

  //opacity用
  gsap.to(intervieweeSet03, {
    opacity: 1,
    scrollTrigger: {
      trigger: scrollArea,
      start: `${WindowHeight * 4}px top`,
      end: `${WindowHeight * 4.25}px top`,
      scrub: 2,
    }
  }, 0);

  //動き用1
  ScrollTrigger.create({
    animation: intervieweeTl1,
    trigger: scrollArea,
    start: `${WindowHeight * 4}px top`,
    end: `${WindowHeight * 6}px top`,
    scrub: 2,
  })

  intervieweeTl1.to(intervieweeSet03, { scale: 3.3, x: 0 });

  //動き用2
  ScrollTrigger.create({
    animation: intervieweeTl2,
    trigger: scrollArea,
    start: `${WindowHeight * 4.25}px top`,
    end: `${WindowHeight * 6}px top`,
    scrub: 2,
  })

  if (window.matchMedia("(min-width: 600px)").matches) {
    intervieweeTl2.to([set03_1, set03_2], { y: 3 * speed }, "<");
    intervieweeTl2.to(set03_1, { x: -100, scale: 2 }, 0);
    intervieweeTl2.to(set03_2, { x: 100, scale: 2 }, 0);
  } else {
    intervieweeTl2.to([set03_1, set03_2], { y: 2 * speed }, "<");
    intervieweeTl2.to(set03_1, { x: -10, scale: 2 }, 0);
    intervieweeTl2.to(set03_2, { x: 10, scale: 2 }, 0);
  }

  //カット用
  ScrollTrigger.create({
    animation: intervieweeCatTl,
    trigger: scrollArea,
    start: `${WindowHeight * 4.75}px top`,
    end: `${WindowHeight * 4.75}px top`,
    scrub: 2,
  })

  intervieweeCatTl.to([set03_1_cat1, set03_2_cat1], { opacity: 0, duration: 1, }, "<");
  intervieweeCatTl.to([set03_1_cat2, set03_2_cat2], { opacity: 1, duration: 1, }, "<");

  //動き用３
  ScrollTrigger.create({
    animation: intervieweeTl3,
    trigger: scrollArea,
    start: `${WindowHeight * 6}px top`,
    end: `${WindowHeight * 6}px top`,
    scrub: 2,
  })

  intervieweeTl3.to([set03_1, set03_2], { opacity: 0 }, 0);
}

/**
 * 小原 由季（おばら ゆい）
 */
function intervieweeSet04Animation() {
  let WindowHeight = setWindowHeight();
  let intervieweeSet04 = document.getElementById('interviewee-set04');
  let set04 = document.getElementById('set04'); //小原 由季（おばら ゆい）
  let set04_cat1 = document.getElementById('set04-cat1');
  let set04_cat2 = document.getElementById('set04-cat2');
  let intervieweeTl1 = gsap.timeline();
  let intervieweeTl2 = gsap.timeline();
  let intervieweeTl3 = gsap.timeline();
  let intervieweeCatTl = gsap.timeline();

  gsap.set(intervieweeSet04, { opacity: 0, scale: 0.5 });

  //opacity用
  gsap.to(intervieweeSet04, {
    opacity: 1,
    scrollTrigger: {
      trigger: scrollArea,
      start: `${WindowHeight * 5}px top`,
      end: `${WindowHeight * 5.25}px top`,
      scrub: 2,
    }
  }, 0);

  //動き用1
  ScrollTrigger.create({
    animation: intervieweeTl1,
    trigger: scrollArea,
    start: `${WindowHeight * 5}px top`,
    end: `${WindowHeight * 7}px top`,
    scrub: 2,
  })

  intervieweeTl1.to(intervieweeSet04, { scale: 3, x: 0 });

  //動き用2
  ScrollTrigger.create({
    animation: intervieweeTl2,
    trigger: scrollArea,
    start: `${WindowHeight * 5.5}px top`,
    end: `${WindowHeight * 7}px top`,
    scrub: 2,
  })

  if (window.matchMedia("(min-width: 600px)").matches) {
    intervieweeTl2.to(set04, { y: 6 * speed, scale: 2 }, "<");
  } else {
    intervieweeTl2.to(set04, { y: 2 * speed, scale: 2 }, "<");
  }


  //カット用
  ScrollTrigger.create({
    animation: intervieweeCatTl,
    trigger: scrollArea,
    start: `${WindowHeight * 5.5}px top`,
    end: `${WindowHeight * 5.5}px top`,
    scrub: 2,
  })

  intervieweeCatTl.to(set04_cat1, { opacity: 0, duration: 1, }, "<");
  intervieweeCatTl.to(set04_cat2, { opacity: 1, duration: 1, }, "<");

  //動き用３
  ScrollTrigger.create({
    animation: intervieweeTl3,
    trigger: scrollArea,
    start: `${WindowHeight * 7}px top`,
    end: `${WindowHeight * 7}px top`,
    scrub: 2,
  })

  intervieweeTl3.to(set04, { opacity: 0 }, 0);
}

/**
 * 
 * __40: MV
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function mvAnimation() {
  let WindowHeight = setWindowHeight();
  let mv = document.getElementById('mv');
  let copy = document.getElementById('copy');
  let copyPath = document.querySelectorAll('#copy path');
  let item01Cat1 = document.getElementById('item01-cat1'); //高村 亮
  let item01Cat2 = document.getElementById('item01-cat2');
  let item02Cat1 = document.getElementById('item02-cat1'); //河野 めぐみ
  let item02Cat2 = document.getElementById('item02-cat2');
  let item03Cat1 = document.getElementById('item03-cat1'); //大場 友喜
  let item03Cat2 = document.getElementById('item03-cat2');
  let item04Cat1 = document.getElementById('item04-cat1'); //小原 由季
  let item04Cat2 = document.getElementById('item04-cat2');
  let item05Cat1 = document.getElementById('item05-cat1'); //城間 亜龍
  let item05Cat2 = document.getElementById('item05-cat2');
  let item06Cat1 = document.getElementById('item06-cat1'); //深谷 実咲
  let item06Cat2 = document.getElementById('item06-cat2');
  let item07Cat1 = document.getElementById('item07-cat1'); //巽 響
  let item07Cat2 = document.getElementById('item07-cat2');
  let mvTl = gsap.timeline();

  gsap.set(copy, { opacity: 0 });
  gsap.set([item01Cat1, item02Cat1, item03Cat1, item04Cat1, item05Cat1, item06Cat1, item07Cat1], { opacity: 0, yPercent: 15 });
  for (let i = 0; i < copyPath.length; i++) {
    gsap.set(copyPath[i], { fill: '#fff' });
  }

  ScrollTrigger.create({
    animation: mvTl,
    trigger: mv,
    start: `top top`,
    end: `+=${WindowHeight * 3}`,
    pin: true,
    scrub: 1,
  });

  mvTl.to(copy, { opacity: 1 });
  mvTl.to([item01Cat1, item07Cat1], { opacity: 1, yPercent: 0 }, "<");
  mvTl.to([item02Cat1, item06Cat1], { opacity: 1, yPercent: 0 });
  mvTl.to([item03Cat1, item05Cat1], { opacity: 1, yPercent: 0 });
  mvTl.to(item04Cat1, { opacity: 1, yPercent: 0 });
  mvTl.to(copyPath[0], { fill: "#4e5c6b" });
  for (let i = 1; i < copyPath.length; i++) {
    mvTl.to(copyPath[i], { fill: "#4e5c6b" }, "<");
  }
  mvTl.to([item01Cat1, item02Cat1, item03Cat1, item04Cat1, item05Cat1, item06Cat1, item07Cat1], { opacity: 0 }, "<");
  mvTl.to([item01Cat2, item02Cat2, item03Cat2, item04Cat2, item05Cat2, item06Cat2, item07Cat2], { opacity: 1 }, "<");
  mvTl.to(copy, { opacity: 1 });
  mvTl.to(copy, { opacity: 1 });
}

/**
 * 
 * __50: 下層ページ - インタビュイー
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function intervieweeMaskScroll() {
  let WindowHeight = setWindowHeight();
  var mask = document.getElementById('mask');
  var maskTrigger = document.getElementById('maskTrigger');
  let maskTl = gsap.timeline();

  ScrollTrigger.create({
    animation: maskTl,
    trigger: maskTrigger,
    start: `top top`,
    end: `+=${WindowHeight * 1}`,
    pin: true,
    scrub: 1.2,
  });

  maskTl.to(mask, { scale: 5 });
}

/**
 * 
 * __60: 下層ページ - 白泉社の職種紹介
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function departmentAside() {
  var Sidebar = document.getElementById('sidebar');
  var position = document.getElementById('page-breadcrumb');
  let asideTl = gsap.timeline();

  ScrollTrigger.create({
    animation: asideTl,
    trigger: position,
    start: `top 75%`,
    end: `bottom 75%`,
    scrub: 1,
  });

  asideTl.to(Sidebar, { opacity: 0 });
}

/**
 * 
 * __00: 実行
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function ScrollAnimation() {
  window.addEventListener("DOMContentLoaded", () => {
    if (window.document.body.classList.contains("home")) {
      bubbleAnimation();
      headerAnimation();
      if (document.getElementById('interviewee')) {
        intervieweeSet01Animation();
        intervieweeSet02Animation();
        intervieweeSet03Animation();
        intervieweeSet04Animation();
      }
      mvAnimation();
    }
    if (window.document.body.classList.contains("interviewee")) {
      intervieweeMaskScroll();
    }
    if (window.document.body.classList.contains("department")) {
      departmentAside();
    }
  });
}

export { ScrollAnimation }